import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const referralSettignRBAC = {
  pageID: '7977b4cad6343b730bdd5f78e01d40b2',
  elementID: {
    ViewPageGeneral: '48dffb8deacb9a5024f7fd6a23df04e4',
    ViewPageBuyer: 'c41020e22dd9842a149d5203a70292e9',
    SaveReferralSetting: 'de19bcc2750cfd8a425849c2c624b20c',
    SaveBuyerSetting: 'f8e3f6ff2099e75c33e6380e79d712d1',
    OpenBuyerTab: 'fe62d30f7b5df3d7c8d696555c31d57b',
    OpenGeneralTab: '68334e5c332a06e268e93b7f93420e7f',
  },
} as const

export const useRBACReferralSettingPage = createUseRBAC(referralSettignRBAC.elementID)

export type UseRBACReferralSettingPageType = ReturnType<typeof useRBACReferralSettingPage>
